import { Inject, Injectable } from '@angular/core';
import { ConfigColors } from '@tangilla/tg-ng-models/src/lib/models/src/utilities/portal-config';
import { PortalConfigService } from '@tangilla/tg-ng-core';
import { TangillaFormsConfig } from '@tangilla/tg-ng-models';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TangillaFormsConfigService {
  isLoading = false;

  favIcon: any = document.querySelector('#tgfFavIcon');
  sidenavLogo?: string;
  sidenavLogoSmall?: string;

  constructor(
    @Inject('env') private env: any,
    private portalConfigService: PortalConfigService) {
  }

  setApplicationConfig(applicationConfig: any) {
    this.isLoading = true;
    this.portalConfigService.portalConfig = applicationConfig;
    this.replaceCssVariables();
    this.processAfterConfigLoad();
    this.isLoading = false;
  }

  private replaceCssVariables() {
    const colors: ConfigColors = this.portalConfigService.portalConfig.association_colors;

    Object.keys(colors).forEach((item) => {
      // @ts-ignore
      document.documentElement.style.setProperty(`--${item}`, colors[item]);
      // @ts-ignore
      document.documentElement.style.setProperty(`--${item}-70`, `${colors[item]}B3`);
      // @ts-ignore
      document.documentElement.style.setProperty(`--${item}-30`, `${colors[item]}4D`);
      // @ts-ignore
      document.documentElement.style.setProperty(`--${item}-15`, `${colors[item]}26`);
      // @ts-ignore
      document.documentElement.style.setProperty(`--${item}-12`, `${colors[item]}1F`);
      // @ts-ignore
      document.documentElement.style.setProperty(`--${item}-4`, `${colors[item]}0A`);
    });
  }

  get tangillaFormsConfig() {
    return this.portalConfigService.portalConfig as TangillaFormsConfig;
  }

  getAssociationFavIcon() {
    return `${environment.api.assets}/associations/${this.portalConfigService.portalConfig.association_nrds_id}/association-fav-icon.png`;
  }

  processAfterConfigLoad(): void {
    this.favIcon.href = this.getAssociationFavIcon();
    if (this.portalConfigService?.portalConfig?.title) {
      document.title = this.portalConfigService?.portalConfig?.title;
    }
  }

  getLogo(isSmall?: boolean) {
    const associationLogoUrl = `${this.env.api.assets}/associations/${this.portalConfigService.portalConfig.association_nrds_id}/association-logo-big-forms.jpg`;

    if (isSmall) {
      return this.sidenavLogoSmall ? this.sidenavLogoSmall : associationLogoUrl;
    }
    return this.sidenavLogo ? this.sidenavLogo : associationLogoUrl;
  }

  getPreviewBackgroundColor() {
    return this.portalConfigService.portalConfig?.color_status['preview']?.color;
  }

  isItLoading() {
    return this.isLoading;
  }
}
